export const DataHooks = { checkIcon: 'checkIcon' };
//# sourceMappingURL=consts.js.map